/**
 * LastEditedBy, a component used to show a user avatar and a last edited by link next to a
 * user-editable field.
 */

import React from 'react';
import UserAvatar from '../Avatar';
import Typography from '@material-ui/core/Typography';


const LastEditedBy = ({lastEditedBy}) => {
    const user = lastEditedBy;
    return (
        <div style={{
            maxWidth: 180,
            float: 'right',
        }}>
            <UserAvatar
                id={user.user_id}
                image={user.image}
                name={user.user_displayname}
                ranger={user.is_ranger}
                staff={user.is_staff}
            />
            <p style={{
                fontSize: 12,
                float: 'right',
                lineHeight: 1.4,
                marginTop: 4,
                marginLeft: 8,
                marginRight: 8,

            }}>
                <Typography style={{display: 'inline'}} variant="caption">
                    Last Edited by
                </Typography>
                <br />
                <a
                    style={{
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: 110}}
                    href={`/profile/${user.user_id}/${user.user_displayname}/`}
                >
                    {user.user_displayname}
                </a>
            </p>
        </div>
    );
};

export default LastEditedBy;
